module.exports = __webpack_public_path__ + "img/titleBg.a887ada7.png";